export default "__VITE_ASSET__f152cd0c__"